export const STATE_RESOLVING = 'resolving'
export const STATE_RESOLVED = 'resolved'
